import TabLink from "hardcover-ui/components/TabLink";
import TabsNavContainer from "components/shared/TabsNavContainer";
import AddBookButton from "./AddBookButton";
import { PageSerializersPromptsLayout } from "types/serializers";

export interface Props {
  prompt: PageSerializersPromptsLayout;
}

export default function PromptNavigation({ prompt }: Props) {
  return (
    <TabsNavContainer>
      <TabLink href={`/prompts/${prompt.slug}`} size="lg">
        <>Top Books</>
      </TabLink>
      <TabLink href={`/prompts/${prompt.slug}/answer`} size="lg">
        <>Your Answers</>
      </TabLink>

      <AddBookButton prompt={prompt} />
    </TabsNavContainer>
  );
}
